import type { ImageProperties } from '../model/form.types';
import type { ImageSource } from '../model/types';

// An image named `logo_*` is the branch logo slot of the header: it follows the branch that
// opens the sheet, whatever URL was saved when the matrix was built in another branch.
export function resolveImageSource(properties: Pick<ImageProperties, 'name' | 'imageUrl'>): ImageSource {
  if ((properties.name ?? '').startsWith('logo_')) return { kind: 'branch-logo' };
  if (properties.imageUrl) return { kind: 'url', url: properties.imageUrl };
  return { kind: 'none' };
}
